import { FC } from "react";
import {
    Box,
    Flex,
    Grid,
    GridItem,
    Heading,
    Text,
    // useBreakpointValue,
} from "@smile2impress/components/relaunch";
import { CheckmarkOutlineIcon, Icon, Picture } from "@smile2impress/components";

import { TreatmentIncludesSectionProps } from "./TreatmentIncludesSection.types";

export const TreatmentIncludesSection: FC<TreatmentIncludesSectionProps> = ({
    content,
}) => {
    const { image, title, items } = content;

    return (
        <Box
            as="section"
            bgColor="base.grey"
            borderRadius={["0", "0", "sm"]}
            overflow="hidden"
            mx={["0", "0", "60px"]}
            h={["auto", "auto", "596px"]}
        >
            <Grid
                gridTemplateColumns={[
                    "repeat(1fr)",
                    "repeat(1fr)",
                    "repeat(24, 1fr)",
                ]}
                gap={0}
                h="100%"
            >
                <GridItem colSpan={["auto", "auto", 12]}>
                    <Picture {...image} h="100%" fit="cover" />
                </GridItem>

                <GridItem colSpan={["auto", "auto", 12]}>
                    <Flex
                        direction="column"
                        px={[2, 2, "76px"]}
                        py={[3, 3, 4]}
                        h="100%"
                    >
                        <Heading
                            as="h2"
                            textStyle="title1"
                            color="text.base"
                            mb={[2, 2, 2]}
                        >
                            {title}
                        </Heading>

                        <Flex direction="column" gap={1}>
                            {items.map((item, index) => (
                                <Flex key={index} gap="8px" align="flex-start">
                                    <Icon
                                        as={CheckmarkOutlineIcon}
                                        w={2}
                                        h={2}
                                        color="base.bitterSweet"
                                        mt="2px"
                                    />
                                    <Text textStyle="body" color="text.base">
                                        {item}
                                    </Text>
                                </Flex>
                            ))}
                        </Flex>
                    </Flex>
                </GridItem>
            </Grid>
        </Box>
    );
};
